import template   from './installation-guide.html'
import controller from './installation-guide.controller'

import './installation-guide.styl'

let component = {
  restrict: 'E',
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/installation/installation-guide/installation-guide.component.js